export default __webpack_public_path__ + "static/media/rocket.81fe3010.png";